export default {
    component: () => import('./index'),
    meta: {
        nav: {
            title: '案例展示'
        }
    }
};
